import type { SuggestedTextItem } from '~entities/suggestedText';
import { ButtonStroked } from '~shared/ui/molecules/Buttons/ButtonStroked';

import { StyledSuggestedText } from './styled';

type Props = {
	send: (props: SuggestedTextItem) => void;
	disabled: boolean;
} & SuggestedTextItem;
export const SuggestedText = ({ text, type, send, disabled }: Props) => (
	<ButtonStroked
		className={StyledSuggestedText}
		onClick={() => send({ text, type })}
		size="M"
		borderRadius="XXS"
		disabled={disabled}
	>
		{text}
	</ButtonStroked>
);
